// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, ".ConnectionMonitor-module__monitor___1TVnA {\n  padding: 30px;\n  font-size: x-large;\n}\n\n.ConnectionMonitor-module__red___1Jj4c {\n  color: red;\n}\n\n.ConnectionMonitor-module__green___1-dsv {\n  color: green;\n}", "",{"version":3,"sources":["ConnectionMonitor.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,YAAY;AACd","file":"ConnectionMonitor.module.css","sourcesContent":[".monitor {\n  padding: 30px;\n  font-size: x-large;\n}\n\n.red {\n  color: red;\n}\n\n.green {\n  color: green;\n}"]}]);
// Exports
exports.locals = {
	"monitor": "ConnectionMonitor-module__monitor___1TVnA",
	"red": "ConnectionMonitor-module__red___1Jj4c",
	"green": "ConnectionMonitor-module__green___1-dsv"
};
module.exports = exports;
